// SELECTED VALUE
export const SUBMIT_CAIR_BPKB_REQUEST = 'SUBMIT_CAIR_BPKB_REQUEST'
export const SUBMIT_CAIR_BPKB_SUCCESS = 'SUBMIT_CAIR_BPKB_SUCCESS'
export const SUBMIT_CAIR_BPKB_FAIL = 'SUBMIT_CAIR_BPKB_FAIL'
export const SUBMIT_CAIR_BPKB_RESET = 'SUBMIT_CAIR_BPKB_RESET'